import axios from 'axios';
import { logger } from './logger';
import { showError } from './notification';

export const request = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const requestStart: { [key: string]: number } = {};

request.interceptors.request.use(req => {
  if (req.url) {
    requestStart[req.url] = new Date().getTime();
    logger.info(`api call started: ${req.url}`);
  }

  return req;
});

request.interceptors.response.use(
  response => {
    const url = response.config.url;

    if (url) {
      const duration = new Date().getTime() - requestStart[url];
      logger.info(`api call completed: ${url}; status: ${response.status}; duration ${duration}ms`);
    }

    return response;
  },
  error => {
    const response = error.response;

    if (response) {
      const url = response.config.url;

      if (url) {
        const duration = new Date().getTime() - requestStart[url];
        const delegatedStatuses = [401, 409, 422];

        if (!delegatedStatuses.includes(response.status)) {
          showError(`An error has occurred while while calling ${url}`);
        }

        logger.error(`api call failed: ${url}; status: ${response.status}; duration ${duration}ms`);
      }
    } else {
      showError(error.message);
      logger.error(`api call error: ${error.message}`);
    }

    throw error;
  }
);